import { Card } from "react-bootstrap";
import CentralCard from "./CentralCard";

const NotFound = () => {    
    return ( 
        <CentralCard>
        <Card>
          <Card.Body>
            <h3>404</h3>
            <p>Nie znaleziono produktu</p>
          </Card.Body>
        </Card>
      </CentralCard>
     );
}

export default NotFound;